import type { ComponentPropsWithRef } from 'react'

import { Container } from './Container'
import { Line } from './Line'

type Props = {
	bold?: boolean
	isActive?: boolean
	slim?: boolean
	/** Size is in em, the height is the base. Defaults to `0.1`, `bold` is `0.15` and `slim` is `0.05`.
	 * Only gets applied if `bold` and `slim` is not set. */
	size?: number
	/** Determines if the edges of the lines are rounded. Defaults to `true`. */
	isRounded?: boolean
} & ComponentPropsWithRef<'span'>

export const ChevronFlip = ({
	isActive = false,
	slim = false,
	bold = false,
	size = 0.1,
	isRounded = true,
	...rest
}: Props) => (
	<Container {...rest}>
		<Line isActive={isActive} slim={slim} bold={bold} size={size} isRounded={isRounded} />
		<Line isActive={isActive} slim={slim} bold={bold} size={size} isRounded={isRounded} mirror />
	</Container>
)
